<template>
  <div class="el-form-items">
    <div class="tit_label">
      <div>
        附加费用
      </div>
      <div class="title" @click="handleChange">
        {{ formOpen ? "收起" : "展开" }}
        <i class="ico" :class="[formOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i>
      </div>
    </div>
    <div class="block" v-show="formOpen">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode || viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    formCtrl: Array,
  },
  data() {
    return {
      formOpen: false,
      viewMode: this.$route.query.mode == 'view',
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        // console.log('form changed', { ...newVal })
        this.checkOpen()
      },
    },
  },
  methods: {
    handleChange() {
      this.formOpen = !this.formOpen;
    },
    onChange(v) {
      // console.log(v, typeof v);
      this.$emit("onChange", v);
    },
    checkOpen() {
      if (this.formCtrl && this.formCtrl.length) {
        this.formCtrl.map(v => {
          const key = v.keyName
          // console.log(key)
          // console.log(this.form[key])
          if (this.form[key] && this.form[key] != 0) {
            this.formOpen = true
          }
        })
      }
    },
  },
  mounted() {
    this.checkOpen()
  },
};
</script>

<style lang="less" scoped>
.el-form-items {
  .tit_label {
    display: flex;

    .title {
      margin-left: 40px;
      cursor: pointer;
    }
  }

}

.tit_label {
  margin: 19px 0 17px 25px;
  font-weight: bold;
  font-size: 18px;
  color: #343434;
}

/deep/ .el-collapse-item__header {
  margin: 17px 0 18px 112px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

/deep/.el-collapse-item__arrow {
  display: none;
}

.el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0 !important;
}

/deep/ .el-textarea__inner {
  font-family: "Microsoft Yahei";
}

.el-col-16 {
  margin-left: -48px;
}
</style>
